import * as Styled from './styled'

export const DividerLine: React.FC = () => {
  return <Styled.DividerLine></Styled.DividerLine>
}
